import { useContext } from "react";
import { TagGroupContext } from "./TagGroupContext";

export const useTagGroupContext = () => {
  const context = useContext(TagGroupContext);

  if (!context) {
    throw new Error(
      "useTagGroupContext must be used within a TagGroupContextProvider",
    );
  }

  return context;
};
